module.exports = __webpack_public_path__ + "img/aptel.ae06925f.jpg";